
const regions = {
  hk: 'HK$',
  sg: 'S$'
}

/**CDN图片压缩 */
export function slimImage(src, option = '') {
  if(!src) return ''
  let image = src.replace(/\?/g,'')
  return image + '?imageView2/0' + option + '/q/75'
}

/**不同的国家返回不同的货币单位 */
export function currency(region) {
  return regions[region] || '￥'
}


function getFront(mainStr,searchStr){
  let foundOffset=mainStr.indexOf(searchStr);
  if(foundOffset==-1){
    return null;
  }
  return mainStr.substring(0,foundOffset);
}

//提取查找字符串后面的所有字符
function getEnd(mainStr,searchStr){
  let foundOffset=mainStr.indexOf(searchStr);
  if(foundOffset==-1){
    return null;
  }
  return mainStr.substring(foundOffset+searchStr.length,mainStr.length);
}


//在字符串 searchStr 前面插入字符串 insertStr
export function insertString(mainStr,searchStr,insertStr){
  var front=getFront(mainStr,searchStr);
  var end=getEnd(mainStr,searchStr);
  if(front!=null && end!=null){
    return front+searchStr+insertStr+end;
  }
  return null;
}
